import React from "react";
import { useLocation, Link } from "react-router-dom";

const PageNotFound = () => {
    const location = useLocation();

    return (
        <div style={{ textAlign: "center", padding: "50px" }}>
            <h1 style={{ fontSize: "4rem", margin: "0" }}>404</h1>
            <h2 style={{ fontSize: "2rem", margin: "10px 0" }}>Oops! Page Not Found</h2>
            <p style={{ fontSize: "1rem", margin: "10px 0" }}>  We're sorry. The page that you are looking for does not exist</p>

            <div style={{ marginTop: "20px" }}>
                <span>Try these : </span>
                <Link to="/flights" style={{ margin: "0 5px", color: "blue" }}>Flights</Link> |
                <Link to="/hotels" style={{ margin: "0 5px", color: "blue" }}>Hotels</Link> |
                <Link to="/holiday" style={{ margin: "0 5px", color: "blue" }}>Holiday</Link>
            </div>

        </div>
    );
};

export default PageNotFound;